export default defineNuxtPlugin(() => {
  if (!('serviceWorker' in navigator)) return
  if (!import.meta.env.PROD) return

  window.addEventListener('load', () => {
    void navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(
        registrations.map((registration) => registration.unregister())
      ))
      .catch((error) => {
        console.warn('[PWA] Service worker cleanup failed:', error)
      })

    if ('caches' in window) {
      void caches.keys()
        .then((keys) => Promise.all(
          keys
            .filter((key) => key.startsWith('kendrick-'))
            .map((key) => caches.delete(key))
        ))
        .catch((error) => {
          console.warn('[PWA] Cache cleanup failed:', error)
        })
    }
  })
})
